export default "__VITE_ASSET__7ffa8db4__"